import PropTypes from 'prop-types';
import React from 'react';
import thumbnailPic from '../../../../../../static/images/images_placeholder.svg';
import iconPdf from '../../../../../../static/icons/icon-pdf.png';
import modifyImageLink, { formatImageSrcSet } from '../../../../../utils/modifyImageLink';
import { imageModifierTypes } from '../../../../../constants';
import styles from './CellGallery.scss';
import LazyImage from '../../../../LazyImage/LazyImage';

export default class CellGalleryItem extends React.Component {
  handleClick = (evt) => evt.stopPropagation();

  render() {
    const { item } = this.props;

    if (item.raw) {
      return (
        <div className={styles.raw} key={item.thumbnail}>
          <img alt="" src={iconPdf} />
          <a href={item.thumbnail} onClick={this.handleClick}>
            {item.name}
          </a>
        </div>
      );
    }

    return (
      <div className={styles.image} key={item.thumbnail}>
        <LazyImage
          root={this.props.root}
          alt=""
          srcSet={formatImageSrcSet([
            {
              imageUrl: modifyImageLink(item.thumbnail, imageModifierTypes.GALLERY_THUMBNAIL) || thumbnailPic,
              width: 350
            },
            {
              imageUrl: modifyImageLink(item.thumbnail, imageModifierTypes.GALLERY_THUMBNAIL_MOBILE) || thumbnailPic,
              width: 600
            }
          ])}
          sizes="(max-width: 767px) 600px, (min-width: 768px) 350px"
          src={
            encodeURI(modifyImageLink(
              item.thumbnail,
              imageModifierTypes.GALLERY_THUMBNAIL
            )) || thumbnailPic
          }
        />
      </div>
    );
  }
}

CellGalleryItem.propTypes = {
  item: PropTypes.object,
  root: PropTypes.string
};
